import React from 'react';

import type { SvgProps } from '../enums';

export const FlagSX: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55131"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55131)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#E31D1C"
      />
      <mask
        id="mask1_270_55131"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55131)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6V12H16V6H0Z"
          fill="#2E42A5"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 -1V13L10 6L0 -1Z"
        fill="#F7FCFF"
      />
      <mask
        id="mask2_270_55131"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="10"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 -1V13L10 6L0 -1Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_270_55131)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M4.06291 4.59441C4.78126 4.59441 5.36361 4.23749 5.36361 3.7972C5.36361 3.35692 4.78126 3 4.06291 3C3.34455 3 2.76221 3.35692 2.76221 3.7972C2.76221 4.23749 3.34455 4.59441 4.06291 4.59441Z"
          fill="#FBCD17"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M4.17671 3.19269C4.07052 3.19269 3.99507 3.2611 3.99507 3.36406L3.99517 3.37542C3.98947 3.39258 3.98626 3.4117 3.98569 3.43311C3.98421 3.48789 4.00461 3.53358 4.04742 3.57549C4.05006 3.58759 4.05143 3.59762 4.05104 3.6033C4.04844 3.59437 4.03811 3.58688 4.01843 3.57261C3.99045 3.55233 3.94359 3.51835 3.87322 3.44707C3.77186 3.34441 3.69537 3.30422 3.60029 3.32019C3.57146 3.32503 3.54324 3.33518 3.50937 3.34875C3.45535 3.3682 3.40563 3.37272 3.31383 3.3552C3.05873 3.3065 2.77893 3.35428 2.47601 3.49465L2.58112 3.72148C2.83965 3.60168 3.06773 3.56273 3.26696 3.60076C3.40382 3.62689 3.49885 3.61826 3.59407 3.58397C3.6351 3.56853 3.63869 3.56724 3.6417 3.56674C3.63868 3.56724 3.64061 3.5691 3.65329 3.58129C3.66183 3.5895 3.67525 3.60239 3.69531 3.62271C3.72388 3.65165 3.75376 3.67786 3.78426 3.70169C3.72562 3.71744 3.72866 3.72826 3.73942 3.76664C3.74381 3.78228 3.74947 3.80249 3.75278 3.82948C3.76007 3.88906 3.74796 3.9198 3.7584 3.93451C3.77006 3.95093 3.80979 3.94741 3.93588 3.94179C3.96982 3.94028 4.01571 3.93678 4.06867 3.93177C4.17254 3.92194 4.29008 3.90763 4.36231 3.89579C4.43247 3.88429 4.45112 3.88009 4.48054 3.85868L4.48055 3.85867C4.49072 3.84619 4.49943 3.83552 4.50664 3.82601C4.74655 3.79077 4.95989 3.76572 5.14973 3.74845C5.21779 3.74225 5.27249 3.738 5.32545 3.73412C5.33171 3.73406 5.33171 3.73406 5.36249 3.72762L5.36249 3.72762C5.37595 3.7219 5.38151 3.71954 5.38339 3.71875L5.38337 3.7188C5.38422 3.71842 5.38472 3.71819 5.38339 3.71875L5.44467 3.57361L5.38136 3.49705C5.34364 3.4852 5.33948 3.48389 5.33526 3.4837C5.33474 3.48368 5.33421 3.48368 5.33362 3.48367C5.32868 3.48338 5.32688 3.48327 5.32507 3.48321C5.32404 3.48318 5.32301 3.48317 5.32139 3.48314L5.26406 3.48306C5.22253 3.48306 5.18973 3.47955 5.14234 3.47112L5.09827 3.46302C4.90336 3.42726 4.72259 3.42726 4.3392 3.48443L4.31777 3.46806C4.37952 3.45733 4.45471 3.45004 4.53418 3.44581L4.53419 3.44581C4.58222 3.44357 4.58222 3.44357 4.60904 3.44286L4.62078 3.44258L4.61931 3.19271L4.60034 3.19269H4.17671ZM3.96962 3.91645L3.99353 3.91149L4.01707 3.90646L3.96962 3.91645Z"
          fill="#DA610A"
        />
        <path
          // eslint-disable-next-line max-len
          d="M3.9625 4.29035L4.00295 4.29698L4.0434 4.29035C4.53991 4.20895 4.86685 4.21845 5.05628 4.28199C5.2745 4.35519 5.51572 4.33447 5.76938 4.24904C5.68887 4.60793 5.64765 4.94712 5.64765 5.26591C5.64765 5.62932 5.71795 5.92289 5.78174 6.18046C5.78345 6.18737 5.78515 6.19425 5.78685 6.2011C5.84936 6.45331 5.90116 6.66233 5.90116 6.90219C5.90116 7.1175 5.82975 7.23059 5.72994 7.30126C5.61436 7.38308 5.42162 7.43521 5.13578 7.43521C4.73278 7.43521 4.35576 7.54374 4.00862 7.75609L4.00295 7.75202L3.99728 7.75609C3.65014 7.54374 3.27313 7.43521 2.87012 7.43521C2.58428 7.43521 2.39154 7.38308 2.27596 7.30126C2.17615 7.23059 2.10474 7.1175 2.10474 6.90219C2.10474 6.66233 2.15654 6.45331 2.21905 6.2011C2.22075 6.19425 2.22245 6.18737 2.22416 6.18046C2.28796 5.92289 2.35825 5.62932 2.35825 5.26591C2.35825 4.94712 2.31704 4.60793 2.23652 4.24904C2.49018 4.33447 2.7314 4.35519 2.94962 4.28199C3.13905 4.21845 3.46599 4.20895 3.9625 4.29035Z"
          fill="#56C6F5"
          stroke="#E31D1C"
          strokeWidth="0.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M4.39242 5.11208L4.00671 4.76923L3.621 5.11208H3.73528V5.30974L3.13528 5.68351V6.5978H3.021V6.76923H3.13528H4.87814H5.021V6.5978H4.87814V5.68351L4.24957 5.29194V5.11208H4.39242Z"
          fill="#F7FCFF"
        />
        <path
          // eslint-disable-next-line max-len
          d="M3.97595 8.51022C4.50647 8.51022 4.8717 8.4523 5.05977 8.35357C5.10907 8.26973 5.19554 8.2224 5.28755 8.22581C5.70078 8.2411 6.02082 8.06702 6.27241 7.68441C6.54426 7.271 6.59888 6.68376 6.4217 5.91296L6.87151 5.80957C7.07452 6.69274 7.00822 7.40546 6.65805 7.93799C6.34426 8.41517 5.91643 8.67005 5.39429 8.68733C5.12762 8.88479 4.66028 8.97176 3.97595 8.97176C3.31393 8.97176 2.82307 8.84321 2.50825 8.57009C1.79331 8.40119 1.33898 8.11603 1.16033 7.69336C0.969902 7.2428 0.969902 6.61732 1.14754 5.81158L1.59825 5.91095C1.43931 6.63188 1.43931 7.1679 1.58546 7.51368C1.68744 7.75497 1.98376 7.95188 2.48578 8.0884L2.95219 8.18813L2.9298 8.30591C3.15733 8.4389 3.50507 8.51022 3.97595 8.51022Z"
          fill="#FBCD17"
        />
        <path
          // eslint-disable-next-line max-len
          d="M2.35699 4.41199L2.61267 4.51485L2.48483 4.78062L2.84242 4.5963L2.81465 4.73276L2.73798 5.10939L2.8845 4.68051V5.05934L2.97402 4.68051L3.23987 4.76069L2.97402 4.5963L3.23987 4.51485"
          stroke="#73BE4A"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M2.84442 4.96851C2.98249 4.96851 3.09442 4.85658 3.09442 4.71851C3.09442 4.58043 2.98249 4.46851 2.84442 4.46851C2.70635 4.46851 2.59442 4.58043 2.59442 4.71851C2.59442 4.85658 2.70635 4.96851 2.84442 4.96851Z"
          fill="#FBCD17"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M5.32054 4.93669C5.31645 4.76855 5.29777 4.38464 5.21246 4.38464C5.12665 4.38464 5.1136 4.77305 5.11195 4.93962C4.96423 4.9879 4.85303 5.11501 4.85303 5.11501H5.5888C5.5888 5.11501 5.47289 4.98252 5.32054 4.93669Z"
          fill="#F7FCFF"
        />
      </g>
    </g>
  </svg>
);
